(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.directive('userCountrySearch', ['HelperService', UserCountrySearchFn]);

    /* user country search directive */
    function UserCountrySearchFn(HelperService) {

        var directive = {
            link: link,
            restrict: 'E',
            scope: {
                country: '='
            },
            templateUrl: '/app/users/templates/user-country-search.template.html'
        };
        return directive;

        function link(scope, element) {
            // country list
            scope.countries = HelperService.data.countries;
        } // link

    }

})();